import React from 'react';
import MeasureToggle from '../measureToggle.jsx';

export default ({ changeMeasure, retailNettMeasure }) => (
  <div>
    <div style={{ color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '21%', marginLeft: '39%', fontSize: '12px' }}>COMMISSION</div>
    <div style={{ color: 'rgba(0, 0, 0, 0.87)', display: 'inline-block', width: '17%', marginLeft: '8%', fontSize: '12px' }}>RETAIL RATE</div>
    <div style={{ width: '10%', display: 'inline-block' }}>
      <MeasureToggle changeMeasure={changeMeasure} retailNettMeasure={retailNettMeasure} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/middle-action-area/header/commission.jsx